var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("paper",null,{"content":_vm.content})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }